import '../../sass/components/recaptcha/registration.scss';
import runRecaptcha from '../components/recaptcha/index';
import get from '../helpers/data_layer/get';

const form = document.getElementsByName('registration')[0];

runRecaptcha(form, true);

(function setLanguageInputValue() {
  const languageInput = document.getElementsByName('iso_language')[0];
  const userLanguage = get('session.language');
  if (languageInput) {
    languageInput.value = userLanguage;
  }
})();
